import React from 'react';

import Filterable from '@components/Filterable/Filterable';
import HotspotList from './HotspotsList';
import { hotspotsSet } from './constants/hotspotsSet';
import { FILTERS } from './constants';

const Hotspots = () => (
  <Filterable
    customClasses="main-content"
    filters={FILTERS}
    data={hotspotsSet}
    withoutSearch
  >
    <HotspotList />
  </Filterable>
);

export default Hotspots;


// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/Hotspots.js